import styled from 'styled-components';

export const CardsWrapper = styled.div`
  position: relative;
  z-index: 1;
  margin: auto;
  width: fit-content;
  display: grid;
  grid-template-columns: min-content min-content min-content;
  column-gap: 160px;
  padding-bottom: 16px;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    column-gap: 64px;
    padding-bottom: 0;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    display: flex;
    flex-direction: column;
  }
`;
export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  white-space: nowrap;
  justify-content: center;
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    padding: 32px 0;
  }
`;

export const Value = styled.div`
  font-size: 36px;
  line-height: 47px;
  font-weight: 700;
  padding-bottom: 18px;
  color: ${({
    theme: {
      colors: {
        primary: { main },
      },
    },
  }) => main};
  font-family: ${({
    theme: {
      fonts: { spaceGrotesk },
    },
  }) => spaceGrotesk};
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    font-size: 32px;
    padding-bottom: 4px;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    padding-bottom: 0;
  }
`;
export const Label = styled.span`
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    font-size: 14px;
  }
`;
